import { safeValue } from "../pages/repo/vehicles/findVehiclesHelpers";
import { buildAdminExcelDisplayRows } from "./excelSheetDisplay";

/** Omitted from WhatsApp / SMS / email only — Excel and admin cards keep these fields. */
const NOTIFY_OMITTED_LABELS = new Set(["EMI", "POS", "instalment", "Seasoning", "Address"]);

const NOTIFY_LABEL_ALIASES = {
  "Registration Numbers": "Registration No",
  "Chasis Number": "Chassis No",
  "Chasis No": "Chassis No",
  "Bank / NBFC Name": "Bank Name",
};

const NOTIFY_VEHICLE_LABELS = [
  "Loan Number",
  "Registration Numbers",
  "Customer Name",
  "Make",
  "Engine Number",
  "Chasis Number",
  "Model",
  "Bank / NBFC Name",
  "Branch Name",
];

const NOTIFY_BANKER_LABELS = [
  "1st bankar Name",
  "mobile no 1",
  "2nd bankar Name",
  "mobile no 2",
  "3rd bankar Name",
  "mobile no 3",
];

function notifyLabel(label) {
  const aliased = NOTIFY_LABEL_ALIASES[label];
  return String(aliased || label || "")
    .replace(/\bNumbers\b/g, "No")
    .replace(/\bNumber\b/g, "No");
}

function notifyRowsInShareOrder(sourceRows = []) {
  const map = new Map(sourceRows.map((row) => [row.label, row]));
  const pick = (labels) =>
    labels.map((label) => ({
      label: notifyLabel(label),
      value: safeValue(map.get(label)?.value),
    }));
  return {
    vehicle: pick(NOTIFY_VEHICLE_LABELS),
    bankers: pick(NOTIFY_BANKER_LABELS),
  };
}

/** Message rows: loan/vehicle/bank first, then banker contacts. */
export function buildAdminFinancerMessageRows(caseDoc = {}) {
  const { vehicle, bankers } = notifyRowsInShareOrder(
    buildAdminExcelDisplayRows(caseDoc, { strictLoanMobile: true }).filter(
      ({ label }) => !NOTIFY_OMITTED_LABELS.has(label)
    )
  );
  return [...vehicle, ...bankers];
}

export function appendAdminFinancerMessageBody(lines, caseDoc = {}) {
  const { vehicle, bankers } = notifyRowsInShareOrder(
    buildAdminExcelDisplayRows(caseDoc, { strictLoanMobile: true }).filter(
      ({ label }) => !NOTIFY_OMITTED_LABELS.has(label)
    )
  );
  const cell = (value) => {
    const text = safeValue(value);
    return text === "—" || text === "-" ? "" : text;
  };
  vehicle.forEach(({ label, value }) => {
    lines.push(`${label}: ${cell(value)}`);
  });
  lines.push("");
  bankers.forEach(({ label, value }) => {
    lines.push(`${label}: ${cell(value)}`);
  });
  lines.push("");
}
